
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { Address } from '@/store/persons/person'

@Component
  export default class AddressAlignment extends Vue {
  @Prop({ type: String, default: '' }) label!: string;
  @Prop({ type: String, default: '' }) appendOuter!: string;
  @Prop({ type: String, default: '' }) placeholder!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) required!: boolean;
  @Prop({
    type: Array,
    // Valor por defecto cambiado a array vacío para asegurar compatibilidad con la validación de Vuetify
    default: () => [],
  })
  directions!: Array<Address>;

  // Regla personalizada para validar que el array no esté vacío solo si es requerido
  get fieldRequired () {
  // Devuelve un array con la función de validación
  return [
    (v: any) => {
      // Si no es requerido, siempre es válido
      if (!this.required) return true
      // Si es array, debe tener al menos un elemento
      if (Array.isArray(v)) return v.length > 0 || 'Campo requerido'
      // Si no es array, debe ser truthy
      return !!v || 'Campo requerido'
    },
  ]
}

  valid = false;

  $refs!: {
    form: HTMLFormElement;
  };

  validate () {
    return this.$refs.form.validate()
  }

  mounted () {
    this.$refs.form.resetValidation()
  }
  }
